import {
	post,
	isApiError,
} from './utilities/provider';
import type { AxiosRequestConfig } from 'axios';
import {
	type ApiV3,
} from '@teamworksdev/influencer-core';

const RESOURCE = 'payments';

export function useExchangePaymentsService(config?: Omit<AxiosRequestConfig, 'key'>) {
	const getExchangePaymentsOnboardingStatus = async (users: ApiV3.GetPaymentsOnboardingStatusParams) => {
		const response = await post<ApiV3.GetPaymentsOnboardingStatusResponse>(`${RESOURCE}/onboarding-status`, {
			key: 'getExchangePaymentMethods',
			...config,
			...users,
		});
		if (isApiError(response)) throw response;
		return response.data.data;
	};

	return {
		getExchangePaymentsOnboardingStatus,
	};
}
